;(function(){
	require('fullpage.js');

	var SECTION_SELECTOR_CLASS_NAME = 'panel_fullpage';
	var NAVIGATION_ID = 'panel-scrollify-pagination';
	var TEMPLATE_ID = 'panel-scrollify-template';
	var ACTIVE_CLASS = 'panel-pagination__item_active';
	var DEFAULT_CLASS = 'panel-pagination__item';
	var LINK_CLASS = 'panel-pagination__link-text';
	var PANEL_BLACK_CLASS = 'section_black';
	var NAVIGATION_BLACK_CLASS = 'panel-pagination_black';
	var NAVIGATION_ACTIVE_CLASS = 'panel-pagination_active';
	var NAVIGATION_BTN_CLASS = 'hamburger';
	var MOBILE_RESOLUTION = 768;

	var SCROLLABLE =            'fp-scrollable';
	var SCROLLABLE_SEL =        '.' + SCROLLABLE;
	var SLIDES_WRAPPER =        'fp-slides';
	var SLIDES_WRAPPER_SEL =    '.' + SLIDES_WRAPPER;
	var ACTIVE =                'active';
	var SECTION =               'fp-section';
	var SECTION_SEL =           '.' + SECTION;
	var ACTIVE_SEL =            '.' + ACTIVE;
	var SECTION_ACTIVE_SEL =    SECTION_SEL + ACTIVE_SEL;
	var panels;
	var iscrollOptions = {
		scrollbars: false,
		mouseWheel: true,
		hideScrollbars: false,
		fadeScrollbars: false,
		disableMouse: true,
		interactiveScrollbars: true,
		preventDefault: false,
	};



	var iscrollHandler = {
		refreshId: null,
		iScrollInstances: [],

		// Enables or disables the mouse wheel for the active section or all slides in it
		toggleWheel: function(value){
			var scrollable = $(SECTION_ACTIVE_SEL).find(SCROLLABLE_SEL);
			scrollable.each(function(){
				var iScrollInstance = $(this).data('iscrollInstance');
				if(typeof iScrollInstance !== 'undefined' && iScrollInstance){
					if(value){
						iScrollInstance.wheelOn();
					}
					else{
						//iScrollInstance.wheelOff();
					}
				}
			});
		},

		/**
		 * Turns off iScroll for the destination section.
		 * When scrolling very fast on some trackpads (and Apple laptops) the inertial scrolling would
		 * scroll the destination section/slide before the sections animations ends.
		 */
		onLeave: function(){
			iscrollHandler.toggleWheel(false);
		},

		// Turns off iScroll for the leaving section
		beforeLeave: function(){
			iscrollHandler.onLeave()
		},

		// Turns on iScroll on section load
		afterLoad: function(){
			iscrollHandler.toggleWheel(true);
		},

		/**
		 * Called when overflow scrolling is needed for a section.
		 *
		 * @param  {Object} element      jQuery object containing current section
		 * @param  {Number} scrollHeight Current window height in pixels
		 */
		create: function(element, scrollHeight) {
			var scrollable = element.find(SCROLLABLE_SEL);

			scrollable.height(scrollHeight);
			scrollable.each(function() {
				var $this = $(this);
				var iScrollInstance = $this.data('iscrollInstance');
				if (iScrollInstance) {
					$.each(iscrollHandler.iScrollInstances, function(){
						$(this).destroy();
					});
				}

				iScrollInstance = new IScroll($this.get(0), iscrollOptions);
				iscrollHandler.iScrollInstances.push(iScrollInstance);

				//off by default until the section gets active
				//iScrollInstance.wheelOff();

				$this.data('iscrollInstance', iScrollInstance);
			});
		},

		/**
		 * Return a boolean depending on whether the scrollable element is a
		 * the end or at the start of the scrolling depending on the given type.
		 *
		 * @param  {String}  type       Either 'top' or 'bottom'
		 * @param  {Object}  scrollable jQuery object for the scrollable element
		 * @return {Boolean}
		 */
		isScrolled: function(type, scrollable) {

			var scroller = scrollable.data('iscrollInstance');

			//no scroller?
			if (!scroller) {
				return true;
			}

			if (type === 'top') {
				return scroller.y >= 0 && !scrollable.scrollTop();
			} else if (type === 'bottom') {
				return (0 - scroller.y) + scrollable.scrollTop() + 1 + scrollable.innerHeight() >= scrollable[0].scrollHeight;
			}
		},

		/**
		 * Returns the scrollable element for the given section.
		 * If there are landscape slides, will only return a scrollable element
		 * if it is in the active slide.
		 *
		 * @param  {Object}  activeSection jQuery object containing current section
		 * @return {Boolean}
		 */
		scrollable: function(activeSection){
			// if there are landscape slides, we check if the scrolling bar is in the current one or not
			if (activeSection.find(SLIDES_WRAPPER_SEL).length) {
				return activeSection.find(SLIDE_ACTIVE_SEL).find(SCROLLABLE_SEL);
			}
			return activeSection.find(SCROLLABLE_SEL);
		},

		/**
		 * Returns the scroll height of the wrapped content.
		 * If this is larger than the window height minus section padding,
		 * overflow scrolling is needed.
		 *
		 * @param  {Object} element jQuery object containing current section
		 * @return {Number}
		 */
		scrollHeight: function(element) {
			return element.find(SCROLLABLE_SEL).children().first().get(0).scrollHeight;
		},

		/**
		 * Called when overflow scrolling is no longer needed for a section.
		 *
		 * @param  {Object} element      jQuery object containing current section
		 */
		remove: function(element) {
			var scrollable = element.find(SCROLLABLE_SEL);
			if (scrollable.length) {
				var iScrollInstance = scrollable.data('iscrollInstance');
				iScrollInstance.destroy();

				scrollable.data('iscrollInstance', null);
			}
			element.find(SCROLLABLE_SEL).children().first().children().first().unwrap().unwrap();
		},

		/**
		 * Called when overflow scrolling has already been setup but the
		 * window height has potentially changed.
		 *
		 * @param  {Object} element      jQuery object containing current section
		 * @param  {Number} scrollHeight Current window height in pixels
		 */
		update: function(element, scrollHeight) {
			//using a timeout in order to execute the refresh function only once when `update` is called multiple times in a
			//short period of time.
			//it also comes on handy because iScroll requires the use of timeout when using `refresh`.
			clearTimeout(iscrollHandler.refreshId);
			iscrollHandler.refreshId = setTimeout(function(){
				$.each(iscrollHandler.iScrollInstances, function(){
					$(this).get(0).refresh();
				});
			}, 150);

			//updating the wrappers height
			element.find(SCROLLABLE_SEL).css('height', scrollHeight + 'px').parent().css('height', scrollHeight + 'px');
		},

		/**
		 * Called to get any additional elements needed to wrap the section
		 * content in order to facilitate overflow scrolling.
		 *
		 * @return {String|Object} Can be a string containing HTML,
		 *                         a DOM element, or jQuery object.
		 */
		wrapContent: function() {
			return '<div class="' + SCROLLABLE + '"><div class="fp-scroller"></div></div>';
		}
	};


	$('#404-fullpage').fullpage({
		//Navigation
		menu: '#menu',
		lockAnchors: false,
		anchors:['firstPage', 'secondPage'],
		navigation: false,
		navigationPosition: 'right',
		navigationTooltips: ['firstSlide', 'secondSlide'],
		showActiveTooltip: false,
		slidesNavigation: false,
		slidesNavPosition: 'bottom',

		//Scrolling
		css3: true,
		scrollingSpeed: 700,
		autoScrolling: true,
		fitToSection: true,
		fitToSectionDelay: 1000,
		scrollBar: false,
		easing: 'easeInOutCubic',
		easingcss3: 'ease',
		loopBottom: false,
		loopTop: false,
		loopHorizontal: true,
		continuousVertical: false,
		continuousHorizontal: false,
		scrollHorizontally: false,
		interlockedSlides: false,
		dragAndMove: false,
		offsetSections: false,
		resetSliders: false,
		fadingEffect: false,
		normalScrollElements: '#element1, .element2',
		scrollOverflow: true,
		scrollOverflowReset: false,
		scrollOverflowOptions: {
			mouseWheel: true,
			scrollbars: false
		},
		touchSensitivity: 15,
		normalScrollElementTouchThreshold: 5,
		bigSectionsDestination: null,

		//Accessibility
		keyboardScrolling: true,
		animateAnchor: true,
		recordHistory: true,

		//Design
		controlArrows: true,
		verticalCentered: true,
		sectionsColor : [],
		paddingTop: '0',
		paddingBottom: '0',
		fixedElements: '#header, .footer',
		responsiveWidth: 0,
		responsiveHeight: 0,
		responsiveSlides: false,
		parallax: false,
		parallaxOptions: {},

		scrollOverflowHandler: iscrollHandler,

		//Custom selectors
		sectionSelector: '.section',
		slideSelector: '.slide',

		lazyLoading: true,

		//events
		onLeave: function(index, nextIndex, direction){},
		afterLoad: function(anchorLink, index){},
		afterRender: function() {},
		afterResize: function(){},
		afterResponsive: function(isResponsive){},
		afterSlideLoad: function(anchorLink, index, slideAnchor, slideIndex){},
		onSlideLeave: function(anchorLink, index, slideIndex, direction, nextSlideIndex){}
	});
	$('#main-fullpage').fullpage({
		//Navigation
		menu: '#menu',
		lockAnchors: false,
		navigation: false,
		navigationPosition: 'right',
		navigationTooltips: ['firstSlide', 'secondSlide'],
		showActiveTooltip: false,
		slidesNavigation: false,
		slidesNavPosition: 'bottom',

		//Scrolling
		css3: true,
		scrollingSpeed: 700,
		autoScrolling: true,
		fitToSection: true,
		fitToSectionDelay: 1000,
		scrollBar: false,
		easing: 'easeInOutCubic',
		easingcss3: 'ease',
		loopBottom: false,
		loopTop: false,
		loopHorizontal: true,
		continuousVertical: false,
		continuousHorizontal: false,
		scrollHorizontally: false,
		interlockedSlides: false,
		dragAndMove: false,
		offsetSections: false,
		resetSliders: false,
		fadingEffect: false,
		normalScrollElements: '#element1, .element2',
		scrollOverflow: true,
		scrollOverflowReset: false,
		scrollOverflowOptions: {
			mouseWheel: true,
			scrollbars: false
		},
		touchSensitivity: 15,
		normalScrollElementTouchThreshold: 5,
		bigSectionsDestination: null,

		//Accessibility
		keyboardScrolling: true,
		animateAnchor: true,
		recordHistory: true,

		//Design
		controlArrows: true,
		verticalCentered: true,
		sectionsColor : [],
		paddingTop: '0',
		paddingBottom: '0',
		fixedElements: '#header, .footer',
		responsiveWidth: 0,
		responsiveHeight: 0,
		responsiveSlides: false,
		parallax: false,
		parallaxOptions: {},

		scrollOverflowHandler: iscrollHandler,

		//Custom selectors
		sectionSelector: '.' + SECTION_SELECTOR_CLASS_NAME,
		slideSelector: '.slide-fullpage',

		lazyLoading: true,

		//events
		onLeave: sectionLeaveHandler,
		afterLoad: function(anchorLink, index){},
		afterRender: afterRenderFullpage,
		afterResize: afterRenderFullpage,
		afterResponsive: function(isResponsive){},
		afterSlideLoad: function(anchorLink, index, slideAnchor, slideIndex){},
	});



	//move to next section
	document.addEventListener('click', function(e) {
		if (!e.target.matches('.btn-fullpage_next')) {
			return;
		}
		$.fn.fullpage.moveSectionDown();
		e.preventDefault();
	});

	//move to num section
	document.addEventListener('click', function(e) {
		if (!e.target.closest('.btn-fullpage_move')) {
			return;
		}
		$.fn.fullpage.moveTo(e.target.closest('.btn-fullpage_move').getAttribute('href').slice(1));
		e.preventDefault();
	});


	function updateRubberHeight() {
		var rubberList = [];
		var sectionList = [];
		sectionList = Array.prototype.slice.call(
			document.getElementsByClassName(SECTION_SELECTOR_CLASS_NAME)
		);
		sectionList.forEach(function(item) {
			rubberList =  Array.prototype.slice.call(
				item.getElementsByClassName('rubber-block')
			);

			rubberList.forEach(function(item) {
				//item.style.removeProperty('height');
				item.classList.remove('rubber-block_height-100');
			});

			if (document.querySelector('.rubber-block').offsetHeight <= document.documentElement.clientHeight &&
					!item.querySelector('.fp-scroller')
			) {
				rubberList.some(function(item) {
					//item.style.height = '100%';
					item.style.removeProperty('height');
					if (document.documentElement.clientWidth >= MOBILE_RESOLUTION) {
						item.classList.add('rubber-block_height-100');
					}

					if (!isContentFit(item)) {
						item.classList.remove('rubber-block_height-100');
						setColsHeightToFixed(item);
						return true;
					}
					return false;
				});
			} else {
				setColsHeightToFixed(item);
			}
		});
	}

	function setChildrenRubberHeight100(elem) {
		var rubberList = [];
		rubberList =  Array.prototype.slice.call(
			elem.getElementsByClassName('rubber-block')
		);

		rubberList.some(function(item) {
			//item.style.height = '100%';
			if (document.documentElement.clientWidth >= MOBILE_RESOLUTION) {
				item.classList.add('rubber-block_height-100');
			}
			if (!isContentFit(item)) {
				item.classList.remove('rubber-block_height-100');
				return true;
			}
			return false;

		});
	};


	//возвращает - помещается ли контент в элемент.
	function isContentFit(elem) {
		if (!elem.children.length) {
			return true;
		}
		return elem.children[elem.children.length - 1].getBoundingClientRect().bottom <= elem.getBoundingClientRect().bottom;
	}


	function afterRenderFullpage() {


		updateRubberHeight();
		if (!document.getElementById(NAVIGATION_ID))
			return;
		var sectionsElements;
		var isFirstBlack;

		sectionsElements = document.querySelectorAll('.' + SECTION_SELECTOR_CLASS_NAME);
		isFirstBlack = sectionsElements[0].matches('.' + PANEL_BLACK_CLASS);
		sectionsElements = Array.prototype.slice.call(sectionsElements);
		sectionsElements = sectionsElements.map(function (item, i) {
			return {
				sectionName : item.dataset.scrollifySectionName,
				sectionClass : item.dataset.scrollifySectionClass
			};

		});
		document.getElementById(NAVIGATION_ID)
			.innerHTML = _.template(
			document.getElementById(TEMPLATE_ID).innerHTML
		)(
			{sectionsElements: sectionsElements}
		);
		if (isFirstBlack) {
			document.getElementById(NAVIGATION_ID)
				.classList.add(NAVIGATION_BLACK_CLASS);
		}


		document.getElementById(NAVIGATION_ID)
			.querySelector('.hamburger')
			.addEventListener('click', function(e) {
				e = e || event;
				var curTarget;
				curTarget = e.currentTarget;
				if (e.currentTarget.matches('.is-active')) {
					document.getElementById(NAVIGATION_ID).style.height = '0';
					document.querySelector('.panel-pagination__menu-icon_hidden').classList.remove('panel-pagination__menu-icon_hidden');
					setTimeout(function() {
						curTarget.classList.toggle('is-active');
						document.getElementById(NAVIGATION_ID).classList.toggle(NAVIGATION_ACTIVE_CLASS);
					}, 200);
				} else {
					curTarget.classList.toggle('is-active');
					document.getElementById(NAVIGATION_ID).classList.toggle(NAVIGATION_ACTIVE_CLASS);
					setTimeout(function() {
						document.getElementById(NAVIGATION_ID).style.height = '100%';
					},10)

				}


			});
	}


	function hidePopupMenu() {
		document.getElementById(NAVIGATION_ID).style.height = '0';
		document.querySelector('.panel-pagination__menu-icon_hidden').classList.remove('panel-pagination__menu-icon_hidden');
		setTimeout(function() {
			document.getElementById(NAVIGATION_ID)
				.querySelector('.hamburger')
				.classList.remove('is-active');
			document.getElementById(NAVIGATION_ID).classList.remove(NAVIGATION_ACTIVE_CLASS);
		}, 200);
	}


	function sectionLeaveHandler(index, nextIndex, direction) {
		var panels;
		var refSection;
		if (!document.getElementById(NAVIGATION_ID)) {
			return;
		}

		if (document.getElementsByClassName('panel-pagination__menu-icon_hidden').length) {
			hidePopupMenu();
		}


		panels = document.querySelectorAll('.' + SECTION_SELECTOR_CLASS_NAME);
		panels = Array.prototype.slice.call(panels);


		document.getElementById(NAVIGATION_ID)
			.classList.remove(NAVIGATION_BLACK_CLASS);
		if (document.getElementById(NAVIGATION_ID)
				.querySelector('.' + ACTIVE_CLASS)) {
			document.getElementById(NAVIGATION_ID)
				.querySelector('.' + ACTIVE_CLASS)
				.classList.remove(ACTIVE_CLASS);
		} else {
			return; // nav has not create yet
		}

		document.getElementById(NAVIGATION_ID)
			.querySelector('a[href="#' + nextIndex + '"]')
			.closest('.' + DEFAULT_CLASS)
			.classList.add(ACTIVE_CLASS);

		if (panels[nextIndex-1].matches('.' + PANEL_BLACK_CLASS)) {
			document.getElementById(NAVIGATION_ID)
				.classList.add(NAVIGATION_BLACK_CLASS);
		}
		if (document.getElementById(NAVIGATION_ID).matches('.' + NAVIGATION_ACTIVE_CLASS)) {
			document.getElementById(NAVIGATION_ID)
				.querySelector('.' + NAVIGATION_BTN_CLASS).classList.toggle('is-active');
			document.getElementById(NAVIGATION_ID).classList.toggle(NAVIGATION_ACTIVE_CLASS);

		}
	}



	panels = document.querySelectorAll('.' + SECTION_SELECTOR_CLASS_NAME);
	panels = Array.prototype.slice.call(panels);
	panels.forEach(function(item) {
		item.addEventListener('click', showMenu);
	});

	function showMenu(e) {
		if (!e.target.closest('.hamburger')) {
			return;
		}
		e.target.closest('.panel-pagination__menu-icon').classList.add('panel-pagination__menu-icon_hidden');
		document.getElementById(NAVIGATION_ID).classList.toggle(NAVIGATION_ACTIVE_CLASS);
		document.getElementById(NAVIGATION_ID)
			.querySelector('.' + NAVIGATION_BTN_CLASS).classList.toggle('is-active');
		setTimeout(function() {
			document.getElementById(NAVIGATION_ID).style.height = '100%';

		},10)

	}




	/**
	 * Align of .col-sm-6_rubber block in container .row_rubber when iscroll mode turn on
	 */
	function setColsHeightToFixed(item) {
		var colList;

		colList = Array.prototype.slice.call(
			item.querySelectorAll('.col-sm-6_rubber')
		);
		if (colList.length !== 2)
			return;
		colList.reduce(function (previous, current) {
			if (previous) {
				previous.style.removeProperty('height');
			}
			if (current) {
				current.style.removeProperty('height');
			}
			if (previous.offsetHeight == current.offsetHeight || document.documentElement.clientWidth < MOBILE_RESOLUTION || previous.closest('.section_contacts')) {
				return;
			} else if (previous.offsetHeight < current.offsetHeight) {
				if (!previous.querySelector('.carousel')) {
					previous.style.height = current.offsetHeight + 'px';
					setChildrenRubberHeight100(previous);
				}
			} else if (previous.offsetHeight > current.offsetHeight) {
				if (!current.querySelector('.carousel')) {
					current.style.height = previous.offsetHeight + 'px';
					setChildrenRubberHeight100(current);
				}
			}
		})
	}







})();


//////////////////
// WEBPACK FOOTER
// ./frontend/js/fullpage.js
// module id = 5
// module chunks = 0